<template>
  <div class="workerorderindex">
    <top></top>
    <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="{ path: '/workerorderindex'}">
          <span>首页</span>
      </router-link>
      <router-link class="btna color" :to="{ path: '/myorder'}" :style="{backgroundColor:boxBodyColor}">我的工单</router-link>
    </div>
    <div class="content">
      <div>
        <img src="../../assets/workorder/hot.png">
        <span >热点问题</span>
      </div>
      <p v-for="item in hotquestion" >
        <router-link v-if="item.showNote" :to="{path:'/workinformation',query:{'id':item.orderId}}" @click.native='nav(item.orderName)'>{{item.orderName}}</router-link>
        <router-link v-else :to="{path:'/workcommit?',query:{'id':item.orderId}}" @click.native='nav(item.orderName)'>{{item.orderName}}</router-link>
      </p>
    </div>
    <div class="content">
      <div>
        <img src="../../assets/workorder/all.png">
        <span>全部问题分类</span>
      </div>
      <p v-for="item in allquestion" >
        <router-link v-if="item.type==0" :to="{path:'/workaccount?',query:{'id':item.id,'class':''}}" @click.native='nav(item.name)'>{{item.name}}</router-link>
        <router-link v-if="item.type==1" :to="{path:'/workaccount?',query:{'id':item.id,'question':''}}" @click.native='nav(item.name)'>{{item.name}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import * as Urls from '../url.js'
import axios from '@/utils/request.js'
import top from '../workorder/top.vue'
export default {
  name: 'workerorderindex',
  components: {
    top
  },
  data () {
    return {
       kefuis:false,
       hotquestion:['无'],
       allquestion:["无"],
       basurl:Urls.baseurl,
       boxBodyColor:'',
       logoUrl:'',
       companyName:'',
       displayMode:'',
       md5:"",
    }
  },
  mounted(){
      var vm=this;
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')
      vm.logoUrl = sessionStorage.getItem('logoUrl');
      vm.displayMode = sessionStorage.getItem('displayMode')
      this.md5=sessionStorage.getItem("md5");
      //获取热点问题
      axios.get(this.basurl+'/api/visitor/wo/hotQuestions?visitorMd5Code='+this.md5).then(function(response){
          if(response.data.code==1){
              vm.hotquestion=[];
              response.data.data.forEach(function(element, index) {
                  vm.hotquestion.push(element)
              });
          }
       })
      //获取全部问题分类
        axios.get(this.basurl+'/api/visitor/wo/workOrderType/0?visitorMd5Code='+this.md5).then(function(response){

          if(response.data.code==1){
              vm.allquestion=[];
              response.data.data.forEach( function(element, index) {
                  vm.allquestion.push(element)
              });
          }
       })

        //判断客服是否显示
       axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
          if(response.data.code==1){
            vm.kefuis=true;
          }
       })
  },
  methods:{
    nav(name){
       sessionStorage.setItem("navname", name);
       console.log(name)
    },
    //判断跳转页面
    kefugo(){
      var vm=this;
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)

          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus=="waiting"){
              vm.$router.replace({path: 'imLineUp'});
              //window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){
                vm.$router.replace({path: 'imSession'});
               //window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  //window.location.href="#/spirit";
                  vm.$router.replace({path: 'spirit'});
                  console.log('已经跳转了');
                }
                if(obj.target==2){
                  vm.$router.replace({path: 'imDirectory'});
                  //window.location.href="#/imDirectory";
                }
            }
          }
        })
    },
    // classnav(name){
    //     sessionStorage.setItem("navname", name)
    //    sessionStorage.setItem("classname", name)
    // },

  }
}
</script>

<style scoped>
  .content{
    width: 560px;
    overflow: hidden;
    border-radius: 6px;
    border:1px solid #cccccc;
    background: #ffffff;
    margin:0 auto;
    margin-top: 30px;
  }
  .top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
  .content div{
    width: 100%;
    height: 40px;
    text-align: left;
    border-bottom: 1px solid #cccccc;
  }
  .content div img{
    display: block;
    float: left;
    width: 26px;
    height: 26px;
    margin-left: 18px;
    margin-top: 8px;
  }
  .content div span{
     display: block;
    float: left;
    font-size: 14px;
    color: #000;
    font-weight: bold;
    margin-top: 12px;
    margin-left: 14px;
  }
  .content p{
    width: 240px;
    height: 40px;
    float: left;
    text-align: center;
    line-height: 48px;

    font-size: 14px;
  }
  .content p a{
    color: #5987c2;
  }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
 position: absolute;
  right: 86px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/workorder/workerorderindex.vue?51a570c6